<template>
<section :class="['SortPanel', { ShowPanel: props.show  }]">
    <RadioSelectItem v-for="item in items" :key="item.value" :item="item" @selection-change="() => onSelectionChange(item)"/>
</section>

</template>
<script setup lang="ts">
import  RadioSelectItem from "@components/RadioSelectItem/RadioSelectItem.vue";
import { computed } from "vue";
import type { ISelectItem } from '@app/interfaces/dtos/ISelectItem';
import { useRouter } from 'vue-router';
import { ProgrammeSortType } from "@studyportals/search-api-interface";
import { SelectListItemStateType } from "@app/enums/SelectListItemStateType";
import { useSearchStore } from "@stores/useSearchStore";

const searchStore = useSearchStore();
const router = useRouter();

const items = computed<ISelectItem[]>(() => {
    const currentSorting = router.currentRoute.value.query.sorting as string || ProgrammeSortType.DEFAULT;

    return [
        {
            text: "Recommended",
            value: ProgrammeSortType.DEFAULT,
            state: currentSorting === ProgrammeSortType.DEFAULT ? SelectListItemStateType.SELECTED : SelectListItemStateType.ENABLED
        },
        {
            text: "Low tuition fee",
            value: ProgrammeSortType.TUITION,
            state: currentSorting === ProgrammeSortType.TUITION ? SelectListItemStateType.SELECTED : SelectListItemStateType.ENABLED
        }
    ];
});

const props = defineProps({
    show: {
        type: Boolean,
        required: false,
        default: false
    },
});

const onSelectionChange = async (item: ISelectItem) => {
    const currentQuery = { ...router.currentRoute.value.query };

    if (item.value === ProgrammeSortType.TUITION) {
        currentQuery.sorting = item.value;
    } else {
        delete currentQuery.sorting;
    }

    await router.push({ query: currentQuery });
    await searchStore.setPage(1);
}
</script>
<style scoped lang="scss">
.SortPanel {
    display: none;
    align-self: flex-end;
    gap: 0.25rem;
    width: calc(100% - 2rem);
    background: $White;
    z-index: $PentHouse;

    &.ShowPanel {
        display: flex;
        flex-direction: column;
    }

    @include PaddingAreas(1.5, 1);
    @include Shadow(High);

    @include Breakpoint(Large, ExtraLarge) {
        width: 14rem;
        position: absolute;
        margin-top: 2.5rem;
        border-radius: 0.5rem;
        border: 1px solid $Grey-300;
        @include PaddingAreas(1, 1, 0, 1);
    }
}
</style>